/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Agent_Replaces_StalledInputs */

const en_us2_prescription_reason_agent_replaces_stalled = /** @type {(inputs: Prescription_Reason_Agent_Replaces_StalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replaces a lift that stalled`)
};

const pt_br2_prescription_reason_agent_replaces_stalled = /** @type {(inputs: Prescription_Reason_Agent_Replaces_StalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui um exercício que estagnou`)
};

const es_419_prescription_reason_agent_replaces_stalled = /** @type {(inputs: Prescription_Reason_Agent_Replaces_StalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplaza un ejercicio que se estancó`)
};

const pt_pt2_prescription_reason_agent_replaces_stalled = /** @type {(inputs: Prescription_Reason_Agent_Replaces_StalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui um exercício que estagnou`)
};

const fr_fr2_prescription_reason_agent_replaces_stalled = /** @type {(inputs: Prescription_Reason_Agent_Replaces_StalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplace un exercice qui stagnait`)
};

const de_de2_prescription_reason_agent_replaces_stalled = /** @type {(inputs: Prescription_Reason_Agent_Replaces_StalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzt eine Übung, bei der du stagniert hast`)
};

const it_it2_prescription_reason_agent_replaces_stalled = /** @type {(inputs: Prescription_Reason_Agent_Replaces_StalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisce un esercizio in stallo`)
};

/**
* | output |
* | --- |
* | "Replaces a lift that stalled" |
*
* @param {Prescription_Reason_Agent_Replaces_StalledInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_agent_replaces_stalled = /** @type {((inputs?: Prescription_Reason_Agent_Replaces_StalledInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Agent_Replaces_StalledInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_agent_replaces_stalled(inputs)
	if (locale === "es-419") return es_419_prescription_reason_agent_replaces_stalled(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_agent_replaces_stalled(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_agent_replaces_stalled(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_agent_replaces_stalled(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_agent_replaces_stalled(inputs)
	return en_us2_prescription_reason_agent_replaces_stalled(inputs)
});
export { prescription_reason_agent_replaces_stalled as "prescription.reason.agent_replaces_stalled" }